export class InvalidOperationException extends Error {
    constructor(message) {
        super(message);
        this.name = "InvalidOperationException";
        this.stack = this.stack || (new Error()).stack;
    }
}
